import { render, staticRenderFns } from "./CartaoDeJustificativaDeCancelamento.vue?vue&type=template&id=fb760e24&scoped=true"
import script from "./CartaoDeJustificativaDeCancelamento.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDeJustificativaDeCancelamento.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDeJustificativaDeCancelamento.vue?vue&type=style&index=0&id=fb760e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb760e24",
  null
  
)

export default component.exports